<template>
  <FormSelect :placeholder="placeholder" :options="options" v-model="modelValue"/>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FormSelect } from '../Form'
import type { FormSelectValue } from '@/interfaces'
import { CalendarDaysIcon } from '@heroicons/vue/24/solid'

const modelValue = defineModel<FormSelectValue>({ required: true });

const { startYear = new Date().getFullYear() } = defineProps<{
  readonly startYear?: number;
  readonly placeholder: string;
}>();

const options = computed(() => Array.from({ length: new Date().getFullYear() - startYear + 1 }, (_, i) => startYear + i).map(year => {
  return {
    value: year % 100,
    label: year.toString(),
    icon: CalendarDaysIcon
  };
}).reverse());
</script>